import {roomUXApi} from "@/core/api/room.ux.api";

export default {
  setUXInfo: async ({ commit }, groupId) => {
    const data = await roomUXApi.setGroupInfo(groupId)

    commit('UX_INIT', {
      ...data,
      logoImagePath: data.logoImageId ? `${process.env.VUE_APP_S3_IMAGE_URL}/group_ux/${groupId}/${data.logoImageId}` : null,
      loadingImagePath: data.loadingImageId ? `${process.env.VUE_APP_S3_IMAGE_URL}/group_ux/${groupId}/${data.loadingImageId}` : null,
      noneVideoImagePath: data.noneVideoImageId ? `${process.env.VUE_APP_S3_IMAGE_URL}/group_ux/${groupId}/${data.noneVideoImageId}` : null,
      hideVideoImagePath: data.hideVideoImageId ? `${process.env.VUE_APP_S3_IMAGE_URL}/group_ux/${groupId}/${data.hideVideoImageId}` : null,
    })

    return data
  }
}